// extracted by mini-css-extract-plugin
export default {"input":"q9-z","button":"r9-z","selected":"s9-z","unavailable":"t9-z","oos":"u9-z","image":"v9-z","paperCutDisabledOverlay":"w9-z"};